const firebaseConfig = {
    apiKey: "AIzaSyA-XhcawqTH8H8HyQXbEJm_zIY0n_NAlLM",
    authDomain: "camtech-9c4a8.firebaseapp.com",
    projectId: "camtech-9c4a8",
    storageBucket: "camtech-9c4a8.appspot.com",
    messagingSenderId: "234970815221",
    appId: "1:234970815221:web:671a8c5d5176557cc603bc"
  };

  export default firebaseConfig;